import { NAVIGATION_ADMIN_MENU_LIST } from './enums';

export const DefaultTabEnabledMap = {
  trainingEnabled: false,
  assetsEnabled: false,
  analyticsEnabled: false,
  dsrEnabled: false,
  callAIEnabled: false,
  settingsEnabled: false,
  contentEnabled: false,
  usersEnabled: false,
};

export const NAVIGATION_ADMIN_ICON_LIST: { [key: string]: { light: string; filled: string } } = {
  [NAVIGATION_ADMIN_MENU_LIST.TRAINING]: {
    light: 'GRADUATION_CAP',
    filled: 'GRADUATION_CAP_FILLED',
  },
  [NAVIGATION_ADMIN_MENU_LIST.ASSETS]: {
    light: 'FILE_TYPE_PIE_CHART',
    filled: 'FILE_TYPE_PIE_CHART_FILLED',
  },
  [NAVIGATION_ADMIN_MENU_LIST.CALL_AI]: { light: 'WAVE', filled: 'WAVE_FILLED' },
  [NAVIGATION_ADMIN_MENU_LIST.DSR]: { light: 'DSR', filled: 'DSR_FILLED' },
  [NAVIGATION_ADMIN_MENU_LIST.CONTENT_CENTER]: {
    light: 'CONTENT_CENTER',
    filled: 'CONTENT_CENTER_FILLED',
  },
  [NAVIGATION_ADMIN_MENU_LIST.ANALYTICS]: { light: 'ANALYTICS', filled: 'ANALYTICS_FILLED' },
  [NAVIGATION_ADMIN_MENU_LIST.USERS]: { light: 'USERGROUP', filled: 'USERGROUP_FILLED' },
  [NAVIGATION_ADMIN_MENU_LIST.ACCOUNT_SETTINGS]: { light: 'SETTINGS', filled: 'SETTINGS_FILLED' },
};
